// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-detail {
  background: #f3f4f6;
  min-height: 100vh;
  padding-bottom: 60px;
}

.job-detail__hero {
  background: #ffffff;
  padding: 48px 0 40px;
}

.job-detail__hero-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
}

.job-detail__hero-left {
  flex: 1 1;
  min-width: 0;
}

.job-detail__type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eaf9f7;
  border: none;
  color: #0f766e;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 5px 14px;
  border-radius: 999px;
  margin-bottom: 14px;
  box-shadow: none;
}

.job-detail__title {
  margin: 0 0 18px;
  font-size: clamp(2.5rem, 4vw, 3.6rem);
  font-weight: 900;
  line-height: 1.02;
  letter-spacing: -0.02em;
  color: #111827;
  text-wrap: balance;
  text-shadow: none;
}

.job-detail__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.job-detail__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border-radius: 0;
  color: #6b7280;
  font-size: 14px;
  background: transparent;
  border: none;
}

.job-detail__hero-right {
  flex: 0 0 260px;
  width: 260px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 14px;
}

.job-detail__salary {
  width: 100%;
  text-align: center;
  padding: 12px 24px;
  border-radius: 16px;
  font-size: 22px;
  font-weight: 800;
  color: #111827;
  background: #f8fafc;
  border: none;
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
  animation: hero-chip-float 4s ease-in-out infinite;
}

.job-detail__apply {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 15px 18px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  color: #ffffff;
  background: linear-gradient(135deg, #2ec4b6 0%, #26d9ca 100%);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-shadow: 0 6px 22px rgba(46, 196, 182, 0.55);
  animation: apply-float 3s ease-in-out infinite;
  transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
  min-height: 54px;
}
.job-detail__apply::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.18), transparent);
  transition: left 0.45s ease;
}
.job-detail__apply:hover:not(:disabled) {
  background: linear-gradient(135deg, #22a99c 0%, #2ec4b6 100%);
  transform: translateY(-3px);
  box-shadow: 0 14px 32px rgba(46, 196, 182, 0.55);
}
.job-detail__apply:hover:not(:disabled)::before {
  left: 100%;
}
.job-detail__apply:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
  box-shadow: 0 4px 12px rgba(46, 196, 182, 0.4);
}
.job-detail__apply:disabled, .job-detail__apply--disabled {
  animation: apply-disabled-float 3.6s ease-in-out infinite;
  background: #e5e7eb;
  color: #64748b;
  cursor: not-allowed;
  box-shadow: none;
}
.job-detail__apply:disabled::before, .job-detail__apply--disabled::before {
  display: none;
}

.job-detail__apply-icon-slot {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.job-detail__apply-text-slot {
  display: block;
  text-align: center;
  line-height: 1.1;
  min-width: 0;
}

.job-detail__apply-error {
  max-width: 260px;
  margin: 8px 0 0;
  color: #b33a3a;
  font-size: 12px;
  line-height: 1.45;
  text-align: right;
}

@keyframes hero-chip-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}
@keyframes apply-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-1.5px);
  }
}
@keyframes apply-disabled-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-1px);
  }
}
.job-detail__closed-notice {
  width: 100%;
  padding: 12px 0;
  border-radius: 8px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #991b1b;
  background: #fee2e2;
  border: 1.5px solid #fca5a5;
}

.job-detail__container {
  max-width: 1200px;
  margin: 32px auto 0;
  padding: 0 24px;
  display: flex;
  align-items: flex-start;
  gap: 28px;
}

.job-detail__main {
  flex: 1 1;
  min-width: 0;
}

.job-detail__section {
  background: #ffffff;
  border-radius: 16px;
  padding: 30px 30px 26px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: none;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.job-detail__section:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

.job-detail__section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.job-detail__section-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #111827;
}

.job-detail__section-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}

.job-detail__section-text {
  margin: 0;
  color: #4b5563;
  font-size: 15px;
  line-height: 1.8;
  white-space: pre-line;
}

.job-detail-description {
  color: #4b5563;
  font-size: 15px;
  line-height: 1.8;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.job-detail-description > :first-child {
  margin-top: 0;
}
.job-detail-description > :last-child {
  margin-bottom: 0;
}
.job-detail-description p,
.job-detail-description ul,
.job-detail-description ol,
.job-detail-description blockquote,
.job-detail-description pre,
.job-detail-description table {
  margin: 0 0 14px;
  white-space: normal;
}
.job-detail-description h1,
.job-detail-description h2,
.job-detail-description h3,
.job-detail-description h4,
.job-detail-description h5,
.job-detail-description h6 {
  margin: 22px 0 10px;
  color: #111827;
  line-height: 1.35;
}
.job-detail-description ul,
.job-detail-description ol {
  padding-left: 24px;
}
.job-detail-description li + li {
  margin-top: 6px;
}
.job-detail-description a {
  color: #0f766e;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.job-detail-description img,
.job-detail-description video,
.job-detail-description iframe {
  max-width: 100%;
}
.job-detail-description img {
  height: auto;
}
.job-detail-description table,
.job-detail-description pre {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}
.job-detail-description blockquote {
  padding-left: 16px;
  border-left: 3px solid #99e2dc;
  color: #6b7280;
}

.job-detail__sidebar {
  width: 280px;
  flex-shrink: 0;
  position: sticky;
  top: 88px;
  align-self: flex-start;
}

.job-detail__side-block {
  background: #ffffff;
  border-radius: 16px;
  padding: 22px 22px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: none;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  animation: side-block-float 5.2s ease-in-out infinite;
}
.job-detail__side-block:hover {
  animation-play-state: paused;
  transform: translateY(-4px);
  box-shadow: 0 10px 26px rgba(15, 44, 53, 0.16);
}

.job-detail__side-block:nth-child(2) {
  animation-delay: 0.8s;
}

.job-detail__side-block:nth-child(3) {
  animation-delay: 1.6s;
}

@keyframes side-block-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2.5px);
  }
}
.job-detail__side-block-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  color: #6b7280;
}
.job-detail__side-block-title h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #111827;
}

.job-detail__info-chip {
  display: inline-block;
  background: #f3f4f6;
  color: #111827;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
}

.job-detail__skills,
.job-detail__positions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.job-detail__skills .skill {
  display: inline-block;
  background: #fffbf3;
  color: #92400e;
  border: 1px solid #fde68a;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
.job-detail__skills .skill:hover {
  background: #fef3c7;
  transform: translateY(-1px) scale(1.03);
  box-shadow: 0 6px 14px rgba(245, 158, 11, 0.2);
}

.job-detail__position-chip {
  display: inline-block;
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
.job-detail__position-chip:hover {
  background: #dbeafe;
  transform: translateY(-1px) scale(1.03);
  box-shadow: 0 6px 14px rgba(59, 130, 246, 0.22);
}

.job-detail__feedback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 80px auto;
  max-width: 480px;
  padding: 40px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  text-align: center;
  color: #6b7280;
  font-size: 15px;
}
.job-detail__feedback--error {
  color: #dc2626;
  border-color: #fca5a5;
  background: #fef2f2;
}

.job-detail__spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #2ec4b6;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 960px) {
  .job-detail__container {
    flex-direction: column;
  }
  .job-detail__sidebar {
    width: 100%;
    position: relative;
    top: auto;
  }
}
@media (max-width: 640px) {
  .job-detail__hero-inner {
    flex-direction: column;
  }
  .job-detail__hero-right {
    flex: 1 1 auto;
    width: 100%;
  }
  .job-detail__title {
    font-size: 26px;
  }
  .job-detail__section {
    padding: 20px 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/JobDetail.scss"],"names":[],"mappings":"AAUA;EACE,mBAPQ;EAQR,iBAAA;EACA,oBAAA;AATF;;AAYA;EACE,mBAZM;EAaN,oBAAA;AATF;;AAYA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AATF;;AAYA;EACE,SAAA;EACA,YAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AATF;;AAYA;EACE,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cA1Da;EA2Db,kBAAA;EACA,iBAAA;AATF;;AAYA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,cA1Ee;EA2Ef,eAAA;EACA,uBAAA;EACA,YAAA;AATF;;AAYA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,SAAA;AATF;;AAYA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBA3FU;EA4FV,eAAA;EACA,gBAAA;EACA,cAlGa;EAmGb,mBAAA;EACA,YAAA;EACA,6BAAA;UAAA,qBAAA;EACA,kDAAA;AATF;;AAYA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBA5GU;EA6GV,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAlHM;EAmHN,6DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,8CAAA;EACA,8EAAA;EACA,gBAAA;AATF;AAWE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uFAAA;EACA,2BAAA;AATJ;AAYE;EACE,6DAAA;EACA,2BAAA;EACA,gDAAA;AAVJ;AAYI;EACE,UAAA;AAVN;AAcE;EACE,oCAAA;EACA,8CAAA;AAZJ;AAeE;EAEE,yDAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAdJ;AAgBI;EACE,aAAA;AAdN;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE;IAEE,wBAAA;EAjBF;EAmBA;IACE,2BAAA;EAjBF;AACF;AAoBA;EACE;IAEE,wBAAA;EAnBF;EAqBA;IACE,6BAAA;EAnBF;AACF;AAsBA;EACE;IAEE,wBAAA;EArBF;EAuBA;IACE,2BAAA;EArBF;AACF;AAwBA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;AAtBF;;AAyBA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,SAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,mBAtPM;EAuPN,mBAtPU;EAuPV,uBAAA;EACA,mBAAA;EACA,0CAvPY;EAwPZ,YAAA;EACA,uDAAA;AAtBF;AAwBE;EACE,yCAAA;EACA,2BAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAvBF;AAyBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAjRW;AA0Pf;;AA2BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAxBF;AA0BE;EACE,aAAA;AAxBJ;AA2BE;EACE,gBAAA;AAzBJ;AA4BE;;;;;;EAME,gBAAA;EACA,mBAAA;AA1BJ;AA6BE;;;;;;EAME,mBAAA;EACA,cAxUW;EAyUX,iBAAA;AA3BJ;AA8BE;;EAEE,kBAAA;AA5BJ;AA+BE;EACE,eAAA;AA7BJ;AAgCE;EACE,cAAA;EACA,0BAAA;EACA,0BAAA;AA9BJ;AAiCE;;;EAGE,eAAA;AA/BJ;AAkCE;EACE,YAAA;AAhCJ;AAmCE;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;AAjCJ;AAoCE;EACE,kBAAA;EACA,8BAAA;EACA,cA9Wa;AA4UjB;;AAsCA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;AAnCF;;AAsCA;EACE,mBAzXM;EA0XN,mBAzXU;EA0XV,uBAAA;EACA,mBAAA;EACA,0CA1XY;EA2XZ,YAAA;EACA,uDAAA;EACA,qDAAA;AAnCF;AAqCE;EACE,4BAAA;EACA,2BAAA;EACA,8CAAA;AAnCJ;;AAuCA;EACE,qBAAA;AApCF;;AAuCA;EACE,qBAAA;AApCF;;AAuCA;EACE;IAEE,wBAAA;EArCF;EAuCA;IACE,6BAAA;EArCF;AACF;AAwCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAlae;AA4XjB;AAwCE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cA3aW;AAqYf;;AA0CA;EACE,qBAAA;EACA,mBAAA;EACA,cAlba;EAmbb,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AAvCF;;AA0CA;;EAEE,aAAA;EACA,eAAA;EACA,QAAA;AAvCF;;AA0CA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,8EAAA;AAvCF;AAyCE;EACE,mBAAA;EACA,uCAAA;EACA,8CAAA;AAvCJ;;AA2CA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,8EAAA;AAxCF;AA0CE;EACE,mBAAA;EACA,uCAAA;EACA,+CAAA;AAxCJ;;AA4CA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBA3eM;EA4eN,mBA3eU;EA4eV,yBAAA;EACA,0CA3eY;EA4eZ,kBAAA;EACA,cAlfe;EAmff,eAAA;AAzCF;AA2CE;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AAzCJ;;AA6CA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAngBM;EAogBN,kBAAA;EACA,qCAAA;AA1CF;;AA6CA;EACE;IAAK,yBAAA;EAzCL;AACF;AA2CA;EACE;IACE,sBAAA;EAzCF;EA4CA;IACE,WAAA;IACA,kBAAA;IACA,SAAA;EA1CF;AACF;AA6CA;EACE;IACE,sBAAA;EA3CF;EA8CA;IACE,cAAA;IACA,WAAA;EA5CF;EA+CA;IACE,eAAA;EA7CF;EAgDA;IACE,kBAAA;EA9CF;AACF","sourcesContent":["$brand: #2ec4b6;\n$brand-dark: #22a99c;\n$text-primary: #111827;\n$text-secondary: #6b7280;\n$bg-page: #f3f4f6;\n$white: #ffffff;\n$radius-xl: 16px;\n$radius-md: 10px;\n$shadow-card: 0 2px 12px rgba(0, 0, 0, 0.07);\n\n.job-detail {\n  background: $bg-page;\n  min-height: 100vh;\n  padding-bottom: 60px;\n}\n\n.job-detail__hero {\n  background: $white;\n  padding: 48px 0 40px;\n}\n\n.job-detail__hero-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 32px;\n  flex-wrap: wrap;\n}\n\n.job-detail__hero-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.job-detail__type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #eaf9f7;\n  border: none;\n  color: #0f766e;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  padding: 5px 14px;\n  border-radius: 999px;\n  margin-bottom: 14px;\n  box-shadow: none;\n}\n\n.job-detail__title {\n  margin: 0 0 18px;\n  font-size: clamp(2.5rem, 4vw, 3.6rem);\n  font-weight: 900;\n  line-height: 1.02;\n  letter-spacing: -0.02em;\n  color: $text-primary;\n  text-wrap: balance;\n  text-shadow: none;\n}\n\n.job-detail__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.job-detail__meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0;\n  border-radius: 0;\n  color: $text-secondary;\n  font-size: 14px;\n  background: transparent;\n  border: none;\n}\n\n.job-detail__hero-right {\n  flex: 0 0 260px;\n  width: 260px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: 14px;\n}\n\n.job-detail__salary {\n  width: 100%;\n  text-align: center;\n  padding: 12px 24px;\n  border-radius: $radius-xl;\n  font-size: 22px;\n  font-weight: 800;\n  color: $text-primary;\n  background: #f8fafc;\n  border: none;\n  backdrop-filter: none;\n  animation: hero-chip-float 4s ease-in-out infinite;\n}\n\n.job-detail__apply {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 15px 18px;\n  border: none;\n  border-radius: $radius-md;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  color: $white;\n  background: linear-gradient(135deg, #2ec4b6 0%, #26d9ca 100%);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 6px 22px rgba(46, 196, 182, 0.55);\n  animation: apply-float 3s ease-in-out infinite;\n  transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;\n  min-height: 54px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.18), transparent);\n    transition: left 0.45s ease;\n  }\n\n  &:hover:not(:disabled) {\n    background: linear-gradient(135deg, #22a99c 0%, #2ec4b6 100%);\n    transform: translateY(-3px);\n    box-shadow: 0 14px 32px rgba(46, 196, 182, 0.55);\n\n    &::before {\n      left: 100%;\n    }\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0) scale(0.98);\n    box-shadow: 0 4px 12px rgba(46, 196, 182, 0.4);\n  }\n\n  &:disabled,\n  &--disabled {\n    animation: apply-disabled-float 3.6s ease-in-out infinite;\n    background: #e5e7eb;\n    color: #64748b;\n    cursor: not-allowed;\n    box-shadow: none;\n\n    &::before {\n      display: none;\n    }\n  }\n}\n\n.job-detail__apply-icon-slot {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.job-detail__apply-text-slot {\n  display: block;\n  text-align: center;\n  line-height: 1.1;\n  min-width: 0;\n}\n\n.job-detail__apply-error {\n  max-width: 260px;\n  margin: 8px 0 0;\n  color: #b33a3a;\n  font-size: 12px;\n  line-height: 1.45;\n  text-align: right;\n}\n\n@keyframes hero-chip-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-2px);\n  }\n}\n\n@keyframes apply-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-1.5px);\n  }\n}\n\n@keyframes apply-disabled-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-1px);\n  }\n}\n\n.job-detail__closed-notice {\n  width: 100%;\n  padding: 12px 0;\n  border-radius: 8px;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 700;\n  color: #991b1b;\n  background: #fee2e2;\n  border: 1.5px solid #fca5a5;\n}\n\n.job-detail__container {\n  max-width: 1200px;\n  margin: 32px auto 0;\n  padding: 0 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: 28px;\n}\n\n.job-detail__main {\n  flex: 1;\n  min-width: 0;\n}\n\n.job-detail__section {\n  background: $white;\n  border-radius: $radius-xl;\n  padding: 30px 30px 26px;\n  margin-bottom: 24px;\n  box-shadow: $shadow-card;\n  border: none;\n  transition: box-shadow 0.25s ease, transform 0.25s ease;\n\n  &:hover {\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    transform: translateY(-3px);\n  }\n}\n\n.job-detail__section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n\n  h3 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 700;\n    color: $text-primary;\n  }\n}\n\n.job-detail__section-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 16px;\n}\n\n.job-detail__section-text {\n  margin: 0;\n  color: #4b5563;\n  font-size: 15px;\n  line-height: 1.8;\n  white-space: pre-line;\n}\n\n.job-detail-description {\n  color: #4b5563;\n  font-size: 15px;\n  line-height: 1.8;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  p,\n  ul,\n  ol,\n  blockquote,\n  pre,\n  table {\n    margin: 0 0 14px;\n    white-space: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 22px 0 10px;\n    color: $text-primary;\n    line-height: 1.35;\n  }\n\n  ul,\n  ol {\n    padding-left: 24px;\n  }\n\n  li + li {\n    margin-top: 6px;\n  }\n\n  a {\n    color: #0f766e;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n  }\n\n  img,\n  video,\n  iframe {\n    max-width: 100%;\n  }\n\n  img {\n    height: auto;\n  }\n\n  table,\n  pre {\n    display: block;\n    max-width: 100%;\n    overflow-x: auto;\n  }\n\n  blockquote {\n    padding-left: 16px;\n    border-left: 3px solid #99e2dc;\n    color: $text-secondary;\n  }\n}\n\n.job-detail__sidebar {\n  width: 280px;\n  flex-shrink: 0;\n  position: sticky;\n  top: 88px;\n  align-self: flex-start;\n}\n\n.job-detail__side-block {\n  background: $white;\n  border-radius: $radius-xl;\n  padding: 22px 22px 20px;\n  margin-bottom: 20px;\n  box-shadow: $shadow-card;\n  border: none;\n  transition: transform 0.22s ease, box-shadow 0.22s ease;\n  animation: side-block-float 5.2s ease-in-out infinite;\n\n  &:hover {\n    animation-play-state: paused;\n    transform: translateY(-4px);\n    box-shadow: 0 10px 26px rgba(15, 44, 53, 0.16);\n  }\n}\n\n.job-detail__side-block:nth-child(2) {\n  animation-delay: 0.8s;\n}\n\n.job-detail__side-block:nth-child(3) {\n  animation-delay: 1.6s;\n}\n\n@keyframes side-block-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-2.5px);\n  }\n}\n\n.job-detail__side-block-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n  color: $text-secondary;\n\n  h4 {\n    margin: 0;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $text-primary;\n  }\n}\n\n.job-detail__info-chip {\n  display: inline-block;\n  background: #f3f4f6;\n  color: $text-primary;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid #e5e7eb;\n}\n\n.job-detail__skills,\n.job-detail__positions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.job-detail__skills .skill {\n  display: inline-block;\n  background: #fffbf3;\n  color: #92400e;\n  border: 1px solid #fde68a;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n\n  &:hover {\n    background: #fef3c7;\n    transform: translateY(-1px) scale(1.03);\n    box-shadow: 0 6px 14px rgba(245, 158, 11, 0.2);\n  }\n}\n\n.job-detail__position-chip {\n  display: inline-block;\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #bfdbfe;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 700;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n\n  &:hover {\n    background: #dbeafe;\n    transform: translateY(-1px) scale(1.03);\n    box-shadow: 0 6px 14px rgba(59, 130, 246, 0.22);\n  }\n}\n\n.job-detail__feedback {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin: 80px auto;\n  max-width: 480px;\n  padding: 40px;\n  background: $white;\n  border-radius: $radius-xl;\n  border: 1px solid #e5e7eb;\n  box-shadow: $shadow-card;\n  text-align: center;\n  color: $text-secondary;\n  font-size: 15px;\n\n  &--error {\n    color: #dc2626;\n    border-color: #fca5a5;\n    background: #fef2f2;\n  }\n}\n\n.job-detail__spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e5e7eb;\n  border-top-color: $brand;\n  border-radius: 50%;\n  animation: spin 0.75s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 960px) {\n  .job-detail__container {\n    flex-direction: column;\n  }\n\n  .job-detail__sidebar {\n    width: 100%;\n    position: relative;\n    top: auto;\n  }\n}\n\n@media (max-width: 640px) {\n  .job-detail__hero-inner {\n    flex-direction: column;\n  }\n\n  .job-detail__hero-right {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n\n  .job-detail__title {\n    font-size: 26px;\n  }\n\n  .job-detail__section {\n    padding: 20px 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
